<nav class="navbar navbar-expand-lg">
  <div class="container-fluid" style="padding-left: 0;">
    <a class="navbar-brand" routerLinkActive="active" routerLink="/home" style="margin-right: 0;"> <img
        src="assets/images/logo.png">
    </a>
    <!-- <a class="navbar-brand" routerLinkActive="active" routerLink="/home" style="margin-right: 0;"> <img
        src="assets/images/logo.svg">
      @if(isLoggedIn) { <span class="casi-name-text"> User: {{me!.fullName}}</span> }</a> -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent" style="padding-right: 23px;">
      <!-- adds to 50 total -->
      <ul class="mb-2 mb-lg-0 ms-auto navbar-nav">

        <!-- <li class="nav-item">
          <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            routerLink="/about">About Us</a>
        </li> -->
        @if(settings.testFlag()){
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            routerLink="/test-page">TEST PAGE</a>
        </li>
        }

        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            routerLink="/coppr">COPPR</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            routerLink="/contact-us">Contact Us</a>
        </li>

        @if(authTokenService.loggedInComputed()){

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Manage
          </a>
          <ul class="dropdown-menu">

            @for(line of menu; track line.id) {
            <a class="dropdown-item" routerLink="{{line.url}}" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show">{{line.title}}</a>
            }
            <!--            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/admin-enquires-list">Enquiries</a></li>-->
            <!--            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/discipline-list">Manage Disciplines</a></li>-->
            <!--            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/organisation-list">Manage Organisations</a></li>-->
          </ul>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">Users</a>
          <ul class="dropdown-menu">
            @for(line of userMenu; track line.id) {
            <a class="dropdown-item" routerLink="{{line.url}}" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show">{{line.title}}</a>
            }

            <!-- <li><a class="dropdown-item" routerLinkActive="active" routerLink="/roles">Roles</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/users">Users</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/user-profile">My User Details</a>
            </li> -->
          </ul>
        </li>
        }
        <!-- @if(isLoggedIn){
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Setup
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" routerLinkActive="active" routerLink="/controlparams">Control Parameters</a>
            </li>
          </ul>
        </li>
        } -->
        @if(authTokenService.loggedInComputed()){
        <li class="nav-item">
          <button type="button" class="nav-link btn" (click)="signOut()" data-bs-toggle="collapse"
            data-bs-target=".navbar-collapse.show">Sign Out</button>
        </li>
        } @else {
        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            routerLink="/login">Login</a>
        </li>
        }
      </ul>
    </div>
  </div>
</nav>
